import { identityReducer } from './identityReducer';
import { IDENTITY_NAMESPACE } from './constants';

export default {
  [IDENTITY_NAMESPACE]: identityReducer,
};
